import config from '@/config'
import moment from 'moment'
import lang from '@/lang'
import { SUBSCRIPTION_MODULES } from '@/modules/base/util/constants'

const datevOAuthResourceUrl = `${config.resourceHost}oauth2/datev`
const datevResourceUrl = `${config.resourceHost}accounting/datev`

const dateTimeFormat = `${config.dateFormat.client} HH:mm`

export default {
  endpoints: {
    resourceUrl: datevResourceUrl,
    authUrl: `${datevOAuthResourceUrl}`,
    authStatus: `${datevOAuthResourceUrl}/status`,
    revoke: `${datevOAuthResourceUrl}/revoke`,
    tokenManagementUrl: 'https://apps.datev.de/tokrevui',
  },

  content: {
    bookingEntries: {
      value: 'bookingEntries',
      subscriptionModules: [SUBSCRIPTION_MODULES.INVOICES, SUBSCRIPTION_MODULES.EXPENSES, SUBSCRIPTION_MODULES.REVENUES],
    },
    documents: {
      value: 'documents',
      subscriptionModules: [],
    },
  },

  requiredScopesForContent: {
    bookingEntries: ['datev:accounting:extf-files-import'],
    documents: ['accounting:documents'],
  },

  documentTypes: {
    invoices: 'invoices',
    expenses: 'expenses',
    others: 'others',
    bankBookings: 'bankBookings',
    customersVendors: 'customersVendors',
  },

  exportListColumns: [
    {
      width: 120,
      field: 'createdAt',
      headerName: lang.generics.date,
      sort: false,
      suppressMovable: true,
      valueFormatter: ({ value }) => {
        return moment(value).format(dateTimeFormat)
      },
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
    {
      width: 130,
      field: 'exportPeriod',
      headerName: lang.periodLabel,
      sort: false,
      suppressMovable: true,
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
    {
      field: 'content',
      headerName: lang.generics.contents,
      sort: false,
      suppressMovable: true,
      cellRenderer: 'contentCell',
      cellClass: 'datevExportContentCell',
      cellStyle: {
        display: 'flex',
        height: '100%',
        overflow: 'auto',
        overflowY: 'auto',
      },
      tooltipField: 'content',
    },
    {
      width: 130,
      field: '',
      headerName: lang.columnHeaderNames.transactionStateTitle,
      sort: false,
      suppressMovable: true,
      cellRenderer: 'actionCell',
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
  ].map((column) => ({ ...column, menuTabs: [] })),
}
